import { FormField } from '@components/admission-modal/admission/admission.type';

import { FIELD_TAX_ID_PT } from './validate-import-csv';

export const formatFormFieldsToBackend = ({ formFields }: { formFields: FormField[] }) =>
  formFields
    .filter((field) => field.isRequired)
    .map(({ name, slug, dataType, isRequired, max, min }) => ({
      name,
      slug: slug ?? null,
      dataType,
      isRequired: slug === FIELD_TAX_ID_PT ? false : isRequired,
      max: max ? Number(max) : undefined,
      min: min || min === 0 ? Number(min) : undefined,
    }));
